module.exports = __webpack_public_path__ + "img/operatori.3596736e.png";